import { render, staticRenderFns } from "./FanCountFacebook.vue?vue&type=template&id=f6dd2040&"
import script from "./FanCountFacebook.vue?vue&type=script&lang=js&"
export * from "./FanCountFacebook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports